/**
 * Step 1 — Template selection cards.
 * @param {{ templates: Array, loading: boolean, error: string|null, onSelect: (id: string) => void }} props
 */
export function TemplateSelect({ templates, loading, error, onSelect }) {
  return (
    <div>
      <div className="text-center mb-10">
        <h2 className="text-base md:text-lg font-black text-white mb-3 tracking-tight">Choose Your Comparison Category</h2>
        <p className="text-slate-400 max-w-xl mx-auto leading-relaxed">
          Each template includes 9 carefully researched comparison features — a mix of objective criteria
          and vendor-sponsored highlights — so you're comparing apples to apples.
        </p>
      </div>

      {error && (
        <div data-testid="checklist-template-error" className="bg-red-900/30 border border-red-700 rounded-lg px-4 py-3 text-red-300 text-sm text-center mb-6">
          {error}
        </div>
      )}

      {loading ? (
        <div data-testid="checklist-templates-loading" className="text-center py-20 text-slate-400">Loading templates…</div>
      ) : (
        <div className="grid sm:grid-cols-3 gap-5">
          {templates.map(t => (
            <button
              key={t.id}
              type="button"
              data-testid={`template-${t.id}`}
              onClick={() => onSelect(t.id)}
              className="text-left bg-slate-800 border border-slate-700 rounded-2xl p-6 hover:border-emerald-500 transition-all duration-200 group focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <span className={`text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-full mb-4 inline-block
                ${t.category === 'consumer'
                  ? 'bg-sky-900/50 text-sky-300 border border-sky-800'
                  : 'bg-violet-900/50 text-violet-300 border border-violet-800'}`}>
                {t.category === 'consumer' ? 'Consumer' : 'Business'}
              </span>
              <h3 className="text-lg font-bold text-white mt-3 mb-2 group-hover:text-emerald-300 transition-colors leading-tight">
                {t.title}
              </h3>
              <p className="text-slate-400 text-sm mb-5 leading-relaxed">{t.subtitle}</p>
              <div className="flex items-center justify-between text-xs text-slate-500">
                <span>{t.feature_count} comparison features</span>
                <span className="text-emerald-600 group-hover:text-emerald-400 font-semibold">Select →</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
